window.addEventListener('load', function() {
  var iframe = document.getElementById('frame_dHhFRDD1yWWTr4pIAazMBQ'); // 获取iframe元素
  console.log('load');

  if (iframe.readyState === 'complete') {
    // iframe已经加载完成，直接执行代码
    handleIframeLoad();
    console.log('complete')
  } else {
    // iframe还未加载完成，添加load事件监听器
    iframe.addEventListener('load', handleIframeLoad);
  }

  function handleIframeLoad() {
    console.log('iframe');

    var iframeDoc = iframe.contentWindow.document; // 获取iframe内部的文档对象

    var elements = iframeDoc.getElementsByClassName('hulk-powered-wrapper'); // 使用getElementByClassName获取内部文档的元素
    if (elements.length > 0) {
      var element = elements[0];
      element.style.display = 'none!important'; // 修改样式
    }
  }
});
